import { render, staticRenderFns } from "./DynamicSection.vue?vue&type=template&id=73a6b09e&scoped=true"
import script from "./DynamicSection.vue?vue&type=script&lang=js"
export * from "./DynamicSection.vue?vue&type=script&lang=js"
import style0 from "./DynamicSection.vue?vue&type=style&index=0&id=73a6b09e&prod&lang=scss&scoped=true"
import style1 from "./DynamicSection.vue?vue&type=style&index=1&id=73a6b09e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6b09e",
  null
  
)

export default component.exports